<template>
  <div class="recode">
    <div class="recode-item" v-for="item of list" :key="item.date">
      <h4>{{item.date}}</h4>
      <div v-for="subsection of item.recodes" class="play-box-item" @click="goDynamicDetails(subsection)" :key="subsection.id" >
          <img src="../../../assets/images/play.svg"/>
          <span class="content">{{subsection.title}}</span>
          <span class="time">{{subsection.time}}</span>
        </div>
    </div>
  </div>
</template>
<script>
import { get } from '../../../utils/request'
import { get as getUser } from '../../../utils/token'
import { isAndroid } from '../../../utils/utils'
export default {
  data () {
    return {
      isAndroid: isAndroid(),
      list: []
    }
  },
  mounted () {
    this.getAllRecode()
  },
  methods: {
    goDynamicDetails (item) {
      this.$router.push(`/exerland/RefiningDetails/${item.curriculum}?chapterId=${item.chapter}&subsection=${item.subsection}`)
    },
    getAllRecode () {
      const user = getUser('user')
      const promise = get({
        url: `/course/getHistory/${user.id}`
      })
      promise.then(res => {
        const { data: { code, detail } } = res
        if (Object.is(code, 200)) {
          const o = {}
          detail.forEach(item => {
            if (o[item.createdTime]) {
              const _o = o[item.createdTime]
              _o.recodes.push(item)
            } else {
              o[item.createdTime] = {
                date: item.createdTime,
                recodes: [item]
              }
            }
            return item
          })
          this.list = Object.values(o)
        }
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.recode {
  padding: 0 6.4%;
  height: 100%;
  background: #fff;
  overflow-y: scroll;
  h4 {
    font-size:12px;
    font-family:PingFangSC-Medium,PingFang SC;
    font-weight:500;
    color:rgba(178,178,178,1);
    line-height:17px;
    padding-bottom: 9px;
    border-bottom: 1px solid rgba(245,245,245,1);
    margin-top: 24px;
  }
  .play-box-item {
      display: flex;
      justify-content:space-between;
      align-items: center;
      padding: 20px 0;
      background:#fff;
      // border-bottom: 1px solid rgba(242,242,247,1);
      position: relative;
      &::after {
        position: absolute;
        left: 0%;
        bottom: 0;
        width: 100%;
        height: 1px;
        content: '';
        background: #F2F2F7;
      }
      img {
        height:12px;
        background:rgba(242,242,247,1);
        border-radius:4px;
        display: block;
        padding: 6px;
      }
      .content {
        font-size:15px;
        font-family:SFProText-Semibold,SFProText;
        font-weight:600;
        color:rgba(51,51,51,1);
        line-height:20px;
        width: 61.6vw;
        text-align: left;
        text-overflow: ellipsis;
        overflow: hidden;
      }
      .time {
        font-size:13px;
        font-family:SFProText-Regular,SFProText;
        font-weight:400;
        color:rgba(60,60,67,0.6);
        line-height:18px;
      }
    }
}
</style>
